import { Image, type ImageSourcePropType } from "react-native";
import { Row, colors } from "@louise/moon-ui";
import { EMBER } from "../../../../onboarding/theme";

export const INTEGRATION_ICON_SIZE = 32;

export function IntegrationLogo({ source }: { source: ImageSourcePropType }) {
  return (
    <Image
      source={source}
      resizeMode="contain"
      style={{ width: INTEGRATION_ICON_SIZE, height: INTEGRATION_ICON_SIZE }}
    />
  );
}

export function IntegrationRow({
  source,
  title,
  subtitle,
  divider,
  trailing,
  onPress,
  testID,
}: {
  source: ImageSourcePropType;
  title: string;
  subtitle: string;
  divider?: boolean;
  trailing?: React.ReactNode;
  onPress?: () => void;
  testID?: string;
}) {
  return (
    <Row
      surface="plain"
      leading={<IntegrationLogo source={source} />}
      leadingSize={INTEGRATION_ICON_SIZE}
      title={title}
      subtitle={subtitle}
      trailing={trailing}
      onPress={onPress}
      action="integration_row"
      chevron={false}
      gap={14}
      paddingHorizontal={16}
      paddingVertical={12}
      borderRadius={0}
      testID={testID}
      titleStyle={{
        fontSize: 15,
        lineHeight: 20,
        fontWeight: "500",
        color: EMBER.colors.text,
      }}
      subtitleStyle={{
        fontSize: 12,
        lineHeight: 16,
        color: EMBER.colors.textLight,
      }}
      style={{
        borderRadius: 0,
        borderTopWidth: divider ? 1 : 0,
        borderTopColor: colors.border,
      }}
    />
  );
}
